export default __webpack_public_path__ + "static/media/slacklogo.4a177a2c.png";